export const doRedirect = (redirectUrl, route = '#/customers') => {
  if (!document.location.hash.includes('/auth/join')) {
    document.location = `https://${
      document.location.host
    }/${document.location.pathname.replace(/^\//, '')}${
      redirectUrl ? decodeURI(redirectUrl) : route
    }`;
    document.location.reload();
  }
};
